<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="body">
      <div class="row">
        <div class="col-12">
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'edit']" />
          </span>
          <h2>{{ $t('resend.pageTitlewpp') }}</h2>
        </div>
      </div>
      <div v-show="!loading" class="options">
        <div class="filters"></div>
        <transition name="fade">
          <div v-if="itemsSelected.length > 0" class="selected-info">
            <span v-if="!allInvites">
              {{
                $t('resend.selectsInfo.clientsLength', {
                  length: itemsSelected.length,
                })
              }}
            </span>
            <span v-if="allInvites">
              {{
                $t('resend.selectsInfo.clientsLength', {
                  length: myInvites.total,
                })
              }}
            </span>
            <span
              v-if="!allInvites"
              @click="allInvites = true"
              class="select-all-customers"
            >
              {{
                $t('resend.selectsInfo.selectAll', {
                  length: myInvites.total,
                })
              }}
            </span>
            <span
              v-if="allInvites"
              @click="allInvites = false"
              class="select-all-customers"
            >
              {{ $t('resend.selectsInfo.cleanSelection') }}
            </span>
          </div>
        </transition>
        <div class="select-all-area">
          <div
            v-if="this.userProfile.permissions.submits.resend"
            class="custom-switch"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-select-resend"
              v-model="selectPage"
              @click="selectAllCheckBoxes($event)"
            />
            <label class="custom-control-label" for="switch-select-resend">
              {{ $t('resend.selectPage') }}
            </label>
          </div>
        </div>
      </div>
      <div v-show="!loading" class="row">
        <div class="col-3">
          <div class="search-answers mt-2">
            <input
              type="text"
              class="form-control"
              id="new-category"
              :placeholder="`${$t('resend.searchInput')}`"
              v-model="filter"
              @keyup="searchByFilter"
            />
            <button @click="cleanFilter" class="btn btn-outline-primary">
              {{ $t('resend.searchButton') }}
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-table
            striped
            id="manual-table"
            class="mt-4"
            :items="myInvites.customers.filter((item) => !item.actionId.paused)"
            :fields="fields"
            :busy="loading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Ação -->
            <template v-slot:cell(action)="row">
              <span>{{ row.item.actionId.name }}</span> <br />
              <span class="user-info">
                {{ $t('resend.metric') }}:
                {{ getMetricLabel(row.item.actionId.type) }}
              </span>
            </template>
            <!-- Cliente -->
            <template v-slot:cell(costumer)="row">
              <span class="user-info">
                {{ checkName(row.item.anonymousResponse, row.item.name) }}
              </span>
              <br />
              <span class="user-info">
                {{ $t('resend.email') }} :
                {{
                  checkUserData(
                    row.item.email,
                    userProfile.permissions.answers.anonymous_profile,
                  )
                }}
              </span>
              <br />
              <span class="user-info">
                {{ $t('resend.phone') }}:
                {{
                  checkUserData(
                    row.item.phone,
                    userProfile.permissions.answers.anonymous_profile,
                  )
                }}
              </span>
              <br />
            </template>
            <!-- Data -->
            <template v-slot:cell(createdAt)="row">
              {{ dateFormat(new Date(row.item.createdAt)) }}
            </template>
            <!-- Data -->
            <template v-slot:cell(resendDates)="row">
              <span v-if="row.item.resendDates.length > 0">
                {{
                  dateFormat(
                    new Date(
                      row.item.resendDates[row.item.resendDates.length - 1],
                    ),
                  )
                }}
              </span>
              <span v-else> - </span>
            </template>
            <!-- Lembrete -->
            <template v-slot:cell(reminder)="row">
              <span v-if="row.item.reminderDates.length > 0">
                {{
                  dateFormat(
                    new Date(
                      row.item.reminderDates[row.item.reminderDates.length - 1],
                    ),
                  )
                }}
              </span>
              <span v-else> - </span>
            </template>
            <!-- Dias -->
            <template v-slot:cell(days)="row">
              {{ setDifferenceInDays(new Date(row.item.createdAt)) }}
            </template>
            <!-- Canal -->
            <template v-slot:cell(channel)="row">
              {{
                row.item.actionId.channel === 'emailsms'
                  ? $t('resend.both')
                  : row.item.actionId.channel
              }}
            </template>
            <!-- Reenviar -->
            <template
              v-slot:cell(options)="row"
              v-if="
                this.userProfile.permissions.submits.resendWpp
              "
            >
              <div
                v-if="
                  row.item.channel !== 'widget' &&
                  !userProfile.permissions.answers.anonymous_profile &&
                  row.item.phone
                "
                style="width: 5px"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    :id="`resend-${row.item._id}`"
                    :value="row.item._id"
                    class="custom-control-input resend-checkbox"
                    @click="check"
                    :checked="verify(row.item._id)"
                  />
                  <label
                    class="custom-control-label"
                    :for="`resend-${row.item._id}`"
                  ></label>
                </div>
              </div>
            </template>
            <template v-slot:cell(url)="row">
              <div>
                <div
                  v-if="
                    !userProfile.permissions.answers.anonymous_profile &&
                    row.item.phone && userProfile.permissions.submits.resendWpp
                  "
                >
                  <div>
                    <i
                      title="WhatsApp Web"
                      v-b-modal="`modal-prevwpp-${row.item._id}`"
                      @click="changeModalText(row.item)"
                      class="fab fa-whatsapp wpp"
                    ></i>
                  </div>
                  <b-modal
                    :id="`modal-prevwpp-${row.item._id}`"
                    size="lg"
                    class="modal-prevwpp"
                    ok-only
                    :title="`${$t('resend.whatsappWebMsg')}`"
                    :ok-title="`${$t('resend.send')}`"
                  >
                    <template slot="modal-footer">
                      <button
                        @click="sendWhatsappWeb(row.item.phone, row.item)"
                        class="btnenviar"
                      >
                        {{ $t('resend.send') }}
                      </button>
                    </template>
                    <div class="col-12" style="padding: 5px">
                      <span style="font-weight: bold">
                        {{ $t('resend.name') }}:
                      </span>
                      <span>
                        {{
                          checkName(row.item.anonymousResponse, row.item.name)
                        }}
                      </span>
                    </div>
                    <div class="col-12" style="padding: 5px">
                      <span style="font-weight: bold">
                        {{ $t('resend.phone') }}:
                      </span>
                      <span>
                        {{
                          checkUserData(
                            row.item.phone,
                            userProfile.permissions.answers.anonymous_profile,
                          )
                        }}
                      </span>
                    </div>
                    <div class="col-12" style="padding: 5px">
                      <span style="font-weight: bold">
                        {{ $t('resend.invitesTable.labels.action') }}:
                      </span>
                      <span>
                        {{ row.item.actionId.name }}
                      </span>
                    </div>
                    <div class="col-12" style="padding: 5px">
                      <span style="font-weight: bold">
                        {{ $t('resend.invitesTable.labels.message') }}:
                      </span>
                      <button
                        @click="copiarMensagem(modalText)"
                        :title="`${$t('resend.invitesTable.labels.copy')}`"
                        class="fas fa-copy copymodal"
                      ></button>
                    </div>
                    <b-form-textarea
                      :id="`txt-${row.item._id}`"
                      v-model="modalText"
                      style="width: 100%; resize: none"
                      rows="10"
                      max-rows="10"
                      columns="80"
                    >
                    </b-form-textarea>
                  </b-modal>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div v-show="!loading" class="row footer" style="display: flex">
        <div class="col-11 pagination-area">
          <div class="pagination-area-manual-answers">
            <paginate
              v-model="currentPage"
              :pageCount="myInvites.paginate || 1"
              :prevText="'‹'"
              :nextText="'›'"
              :activeClass="'active'"
              :containerClass="'pagination b-pagination'"
              :pageClass="'page-item'"
            >
            </paginate>
          </div>
          <a
            v-if="!loadingCSV"
            @click="exportData('csv')"
            :title="`${$t('resend.exportCsv')}`"
            class="mr-2 ml-4"
          >
            <span class="xls">
              <i class="fas fa-file-csv"></i>
            </span>
          </a>
          <div v-else class="text-primary mt-2 mr-4">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
          <a
            v-if="!loadingXLS"
            @click="exportData('xlsx')"
            :title="`${$t('resend.exportXls')}`"
            class="mr-4"
          >
            <span class="xls">
              <i class="fas fa-file-excel"></i>
            </span>
          </a>
          <div v-else class="text-primary mt-2 mr-4">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </div>
        <div class="col-1" style="float: right">
          <a
            v-if="
              this.userProfile.permissions.submits.resendWpp
             "
            @click="sendWhatsapp"
            :title="`${$t('resend.sendWpp')}`"
            class="mr-2"
          >
            <span class="xls">
              <i class="fab fa-whatsapp-square"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import swal from 'sweetalert';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import Paginate from 'vuejs-paginate';
import dashboardBar from '@/components/molecules/dashboard-bar';
import api from '../../../services/api';

const normalize = require('normalize-strings');

export default {
  components: {
    Paginate,
    dashboardBar,
  },

  data: () => ({
    userAuth: null,
    currentPage: 1,
    allInvites: false,
    selectPage: false,
    itemsSelected: [],
    pagesSelected: [],
    loading: true,
    fields: [],
    filter: null,
    loadingXLS: false,
    loadingCSV: false,
    modalText: '',
  }),

  computed: {
    ...mapState('invites', ['myInvites', 'actionInfo']),
    ...mapState('actions', ['myActionId', 'myActionName', 'myActionsIds', 'actionGroupData']),
    ...mapState('companies', ['myMetric']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      { key: 'controlId', label: this.$t('resend.invitesTable.labels.id') },
      { key: 'action', label: this.$t('resend.invitesTable.labels.action') },
      { key: 'costumer', label: this.$t('resend.invitesTable.labels.client') },
      { key: 'createdAt', label: this.$t('resend.invitesTable.labels.submit') },
      {
        key: 'resendDates',
        label: this.$t('resend.invitesTable.labels.lastSend'),
        class: 'text-center',
      },
      {
        key: 'days',
        label: this.$t('resend.invitesTable.labels.days'),
        class: 'text-center',
      },
      {
        key: 'url',
        label: 'WhatsApp',
        class: 'text-center',
      },
    ];
    if (this.userProfile.permissions.submits.resendWpp) {
      this.fields.push({
        key: 'options',
        label: this.$t('resend.invitesTable.labels.select'),
      });
    }
    this.updateTable(1);
  },

  watch: {
    myActionId: function watchMyActionId() {
      this.currentPage = 1;

      this.cleanVariables();

      this.updateTable(1);
    },

    myActionsIds: function watchMyActionsIds() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    calendarDates: function watchCalendarDates() {
      this.updateTable(1);
    },

    currentPage: async function watchPage(page) {
      await this.updateTable(page);

      if (this.allInvites) {
        this.disableChecks(true);
      } else {
        const elements = document.querySelectorAll('.resend-checkbox');

        let count = 0;

        elements.forEach((el) => {
          const found = this.itemsSelected.find((item) => item === el.value);
          if (found) {
            el.checked = true;
            count += 1;
          } else {
            el.checked = false;
          }
        });

        if (count >= elements.length) {
          this.selectPage = true;
        } else {
          this.selectPage = false;
        }
      }
    },

    allInvites: function watchAllInvites(value) {
      if (value) {
        this.disableChecks(true);
      } else {
        this.disableChecks(false);
      }
    },

    filter: function watchFilter() {
      if (this.allInvites) {
        this.allInvites = false;
      }
    },

    myIh1: function watchMyMyIh1() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    myIh2: function watchMyMyIh2() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    myMetric: function watchMyMetric() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    actionGroupData: function watchActionGroup() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    'indicatorData.value': function watchIndicatorData() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },
  },

  methods: {
    ...mapActions('invites', [
      'setInvites',
      'setActionInfo',
      'resendInvites',
      'wppInvites',
    ]),
    ...mapActions('calendar', ['setDates', 'setDefaultDates']),

    checkName(anonymous, name) {
      if (
        anonymous &&
        !this.userProfile.permissions.answers.anonymous_profile
      ) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem nome';
    },

    checkUserData(value, profile) {
      if (value === 'empty') {
        return '-';
      } else if (profile) {
        return '************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    copiarMensagem(text) {
      navigator.clipboard.writeText(text);
      this.$bvToast.toast(this.$t('resend.messages.copyMsg.description'), {
        title: this.$t('resend.messages.copyMsg.title'),
        autoHideDelay: 3000,
        variant: 'success',
        solid: true,
      });
    },

    verify(id) {
      if (this.itemsSelected.indexOf(id) + 1) {
        return true;
      }
      return false;
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.updateTable();
    },

    cleanVariables() {
      this.allInvites = false;
      this.selectPage = false;
      this.itemsSelected = [];
      this.pagesSelected = [];
      this.filter = null;
    },

    disableChecks(disable) {
      const mySwitch = document.getElementById('switch-select-resend');
      const elements = document.querySelectorAll('.resend-checkbox');

      if (disable) {
        mySwitch.disabled = true;
        this.selectPage = true;
        elements.forEach((el) => {
          el.checked = true;
          el.disabled = true;
        });
      } else {
        this.itemsSelected = [];
        mySwitch.disabled = false;
        this.selectPage = false;
        elements.forEach((el) => {
          el.checked = false;
          el.disabled = false;
        });
      }
    },

    changeModalText(item) {
      this.modalText = item.actionId.email.template.plainText;
    },

    normalizeText(text) {
      if (text) {
        const regexSpace = new RegExp(' ', 'gi');
        const convertedText = text.toString();
        const normalizedText = normalize(convertedText)
          .trim()
          .toLowerCase()
          .replace(/ +(?= )/g, '')
          .replace(regexSpace, '_');
        return normalizedText;
      }
      return '';
    },

    replaceTagsOnText({ name, text, indicators }) {
      let replacedText = text;
      const arrayOfTags = [];
      arrayOfTags.push(
        { key: 'nome', value: name },
        { key: 'pnome', value: name ? name.split(' ')[0] : '' },
      );
      if (indicators) {
        indicators.forEach((indicator) => {
          arrayOfTags.push({
            key: this.normalizeText(indicator.column),
            value: indicator.value,
          });
        });
      }
      arrayOfTags.forEach((tag) => {
        const regexForHTML = new RegExp(`&lt;${tag.key}&gt;`, 'gi');
        if (replacedText) {
          replacedText = replacedText.replace(
            regexForHTML,
            tag.value ? tag.value : '',
          );
        }
      });
      return replacedText;
    },
    async buildWppWebMsg() {
      let msg;
      let myName;
      let item;
      let temp;
      for (let i = 0; i < this.myInvites.customers.length; i += 1) {
        item = this.myInvites.customers[i];
        msg = item.actionId.email.template.myHTML;
        msg = msg.replaceAll('<br />', String.fromCharCode(13));
        myName = item.name ? item.name : '';

        if (myName) {
          myName = myName.split(' ')[0];
          myName =
            myName.substring(0, 1).toUpperCase() +
            myName.substring(1).toLowerCase();
          item.name = myName;
        }
        if (
          msg.indexOf('&lt;pnome&gt;') === -1 &&
          msg.indexOf('&lt;nome&gt;') === -1 &&
          myName
        ) {
          msg = `${myName},${String.fromCharCode(13)}${msg}`;
        }
        msg += String.fromCharCode(13);
        msg += String.fromCharCode(13);
        msg += 'Acesse a nossa pesquisa através do link';
        msg += String.fromCharCode(13);
        msg += `${item.shortUrl}-W`;
        msg = this.replaceTagsOnText({
          name: item.name,
          text: msg,
          indicators: item.indicators,
        });
        temp = document.createElement('div');
        temp.innerHTML = msg;
        item.actionId.email.template.plainText =
          temp.textContent || temp.innerText || '';
        temp.remove();
      }
    },

    async sendWhatsappWeb(number, item) {
      this.$bvModal.hide(`modal-prevwpp-${item._id}`);
      const msg = this.modalText;
      const target = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
        number,
      )}&text=${encodeURIComponent(msg)}`;
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = target;
      a.click();
      a.remove();
    },

    sendWhatsapp() {
      if (this.itemsSelected.length === 0 && !this.allInvites) {
        swal({
          title: this.$t('resend.messages.sendNoClient.title'),
          text: this.$t('resend.messages.sendNoClient.description'),
          icon: 'warning',
        });
        return false;
      }

      if (this.allInvites) {
        swal({
          title: this.$t('resend.messages.sendAllInvites.title'),
          text: this.$t('resend.messages.sendAllInvites.description'),
          icon: 'info',
          buttons: [
            this.$t('resend.messages.sendAllInvites.noLabel'),
            this.$t('resend.messages.sendAllInvites.yesLabel'),
          ],
        }).then(async (send) => {
          if (send) {
            this.loading = true;
            const qtdEnviados = await this.wppInvites({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              data: {
                actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
                all: true,
                filter: this.filter,
                startDate: this.calendarDates.start,
                endDate: this.calendarDates.end,
                ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
                ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
                metric: this.myMetric,
                groupId: this.actionGroupData._id,
                indicator: this.indicatorName,
                indicatorValue: this.indicatorData.value,
                indicatorRange: this.indicatorData.range,
              },
            });
            this.cleanVariables();
            this.updateTable(this.currentPage);
            swal(
              `${this.$t('resend.messages.sendAllInvites.sentMsg1')}
              ${qtdEnviados.data.valid}
              ${this.$t('resend.messages.sendAllInvites.sentMsg2')}
              ${qtdEnviados.data.total}
              ${this.$t('resend.messages.sendAllInvites.sentMsg3')} `,
              { icon: 'success' },
            );
          }
        });
      } else {
        swal({
          title: this.$t('resend.messages.sendInvites.title'),
          text: `${this.$t('resend.messages.sendInvites.description1')}
          ${this.itemsSelected.length}
          ${this.$t('resend.messages.sendInvites.description2')}?`,
          icon: 'info',
          buttons: [
            this.$t('resend.messages.sendInvites.noLabel'),
            this.$t('resend.messages.sendInvites.yesLabel'),
          ],
        }).then(async (send) => {
          if (send) {
            this.loading = true;
            const qtdEnviados = await this.wppInvites({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              data: {
                ids: this.itemsSelected,
              },
            });
            this.cleanVariables();
            this.updateTable(this.currentPage);
            swal(
              `${this.$t('resend.messages.sendInvites.sentMsg1')}
              ${qtdEnviados.data.valid}
              ${this.$t('resend.messages.sendInvites.sentMsg2')}
              ${qtdEnviados.data.total}
              ${this.$t('resend.messages.sendInvites.sentMsg3')} `,
              { icon: 'success' },
            );
          }
        });
      }

      return true;
    },

    check(event) {
      let count = 0;
      const elements = document.querySelectorAll('.resend-checkbox');

      if (event.target.checked) {
        this.itemsSelected.push(event.target.value);
      } else {
        this.itemsSelected.splice(
          this.itemsSelected.indexOf(event.target.value),
          1,
        );
      }

      elements.forEach((el) => {
        if (el.checked === true) {
          count += 1;
        }
      });

      if (count === elements.length) {
        this.selectPage = true;
      } else {
        this.selectPage = false;
      }
    },

    selectAllCheckBoxes(event) {
      const elements = document.querySelectorAll('.resend-checkbox');

      if (event.target.checked) {
        elements.forEach((el) => {
          el.checked = true;
        });

        this.myInvites.customers.forEach((el) => {
          if (!(this.itemsSelected.indexOf(el._id) + 1)) {
            this.itemsSelected.push(el._id);
          }
        });
      } else {
        elements.forEach((el) => {
          el.checked = false;
        });

        this.myInvites.customers.forEach((el) => {
          this.itemsSelected.splice(this.itemsSelected.indexOf(el._id), 1);
        });
      }
    },

    async updateTable(page) {
      this.loading = true;

      await this.setInvites({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        queryParams: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          page,
          limit: '10',
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          filter: this.filter,
          active: 'true',
          metric: this.myMetric,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          isPageWpp: true
        },
      });
      await this.buildWppWebMsg();

      this.loading = false;
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },

    setDifferenceInDays(date) {
      const time = new Date() - date.getTime();
      const difference = (time / (1000 * 3600 * 24)).toFixed(0);

      return difference;
    },

    refresh() {
      this.setDates({
        start: null,
        end: null,
        selected: null,
      });
      this.currentPage = 1;
      this.cleanVariables();
      this.updateTable(1);
    },

    async exportData(type) {
      // checks if the total docs to download is greater then 100k
      if (this.myInvites.paginate * 10 > 100000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }
      if (type === 'xlsx') {
        this.loadingXLS = true;
      } else {
        this.loadingCSV = true;
      }

      try {
        await api.get(`invites/download/${this.userAuth.companyId}/${type}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            filter: this.filter,
            active: 'true',
            metric: this.myMetric,
            groupId: this.actionGroupData._id,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
          },
        });

        swal({
          title: this.$t('resend.messages.export.title'),
          text: this.$t('resend.messages.export.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('resend.messages.export.errorTitle'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (type === 'xlsx') {
        this.loadingXLS = false;
      } else {
        this.loadingCSV = false;
      }
    },

    async isQuotaExceeded(companyId, qty) {
      const consumptions = await this.getCompanyConsumption();
      let exceededQuotaEmail = false;
      let exceededQuotaSms = false;
      let balanceEmail = 0;
      let balanceSms = 0;
      let balanceMsg = 0;
      let exceededQuota = null;
      // check email balance
      if (consumptions.plan.qtyEmail) {
        balanceEmail = consumptions.plan.qtyEmail - consumptions.totalEmail;
        if (balanceEmail < 0) {
          balanceEmail = 0;
        }
        if (qty >= balanceEmail) {
          exceededQuotaEmail = true;
        }
      }
      // check sms balance
      if (consumptions.plan.qtySms) {
        balanceSms = consumptions.plan.qtySms - consumptions.totalSms;
        if (balanceSms < 0) {
          balanceSms = 0;
        }
        if (qty >= balanceSms) {
          exceededQuotaSms = true;
        }
      }
      if (exceededQuotaEmail) {
        balanceMsg = balanceEmail;
      } else if (exceededQuotaSms) {
        balanceMsg = balanceSms;
      }
      if (exceededQuotaEmail || exceededQuotaSms) {
        exceededQuota = { balanceMsg };
      }
      return exceededQuota;
    },

    async getCompanyConsumption() {
      const response = await api.get(`consumption/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      return response.data.consumption;
    },

    getMetricLabel(metric) {
      if (metric === 'nps-0-10') {
        return this.$t('manualAnswer.nps010');
      } else if (metric === 'nps-1-5') {
        return this.$t('manualAnswer.nps15');
      } else if (metric === 'ces-1-5') {
        return this.$t('manualAnswer.ces15');
      } else if (metric === 'csat-1-5') {
        return this.$t('manualAnswer.csat15');
      } else if (metric === 'csat-1-5(media)') {
        return this.$t('manualAnswer.csatAverage15');
      }
      return this.$t('manualAnswer.fiveStars');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.search-answers {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.wrapper {
  padding: 8px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.copy-div {
  color: $primary;
  font-size: 18px;
}

.body {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.body h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}

.user-info {
  color: rgb(133, 131, 131);
}

.table-icons {
  color: $primary;
  padding-left: 25px;
  font-size: 23px;

  svg {
    &:hover {
      color: #46b41e;
      cursor: pointer;
    }
  }
}

.selected-info {
  padding: 10px 30px;
  color: #5f6368;
  background-color: rgba(241, 243, 244, 0.6);
}

.select-all-customers {
  color: #1a73e8;
  cursor: pointer;
}

.pagination-area-manual-answers >>> a {
  position: relative;
  display: block;
  margin-top: 10px;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.options {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  .pagination-area {
    display: flex;
    flex-direction: row;
  }

  .send-buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}
.wpp {
  font-size: 30px;
  color: $primary;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  font-weight: 900;
}

.wpp:hover {
  color: #1dc86e;
}
</style>

<style>
.copy {
  margin-left: 10px;
}
.copy:hover {
  cursor: pointer;
}
.pagination-area-manual-answers .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-manual-answers a {
  outline: none;
}
.myheader {
  background: #7cd1f9 !important;
  border-radius: 0px 0px 20px 20px !important;
  width: 100%;
  height: 50px;
  padding: 10px;
  color: white;
}
.btnenviar {
  padding: 0px;
  background: #4ce595 !important;
  border-radius: 20px !important;
  width: 50%;
  color: white;
}
.copymodal {
  color: #7cd1f9 !important;
  background-color: transparent !important;
  border: none;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/resendwpp/index.vue